<template>
  <v-dialog
    @click:outside="$emit('close')"
    v-model="dialog"
    persistent
    max-width="450px"
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <v-card>
      <v-toolbar dense class="elevation-0 white--text" color="amber darken-1">
        Nhận xét học viên {{ student.student.name }}
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon dark @click="cancel">close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider />
      <v-card-text>
        <v-form lazy v-model="valid" ref="form">
          <v-textarea
            rows="10"
            standard
            label="Nhận xét"
            v-model="note"
            required
            :rules="[$rules.required]"
          ></v-textarea>
        </v-form>
      </v-card-text>
      <v-card-actions class="pr-6 pb-8">
        <v-spacer></v-spacer>
        <v-btn class="px-6" color="primary" @click="save()">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'
export default {
  props: {
    dialog: Boolean,
    student: Object
  },
  data() {
    return {
      note: ((this.student || {}).learningResult || {}).note || '',
      valid: true
    }
  },
  methods: {
    ...mapActions('classDetail', ['updateMarks', 'initClass']),
    reset() {
      this.note = ((this.student || {}).learningResult || {}).note || ''
      this.valid = true
    },
    async save() {
      this.isValid = this.$refs.form.validate()
      if (!this.isValid) {
        this.$alert.error('Lỗi Form! Vui lòng kiểm tra lại')
        return
      }
      if (!this.note) {
        return
      }
      this.$emit('save', this.note)
      this.$emit('close')
    },
    cancel() {
      this.$emit('close')
    }
  },
  watch: {
    dialog() {
      this.reset()
    }
  }
}
</script>
